exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,body{margin:0;padding:0;color:#333;width:100%;height:100%}div{-webkit-box-sizing:border-box;box-sizing:border-box}h1,h2,h3,h4,h5,h6,p{margin:0}h1{font-size:24px}h2{font-size:22px}h3{font-size:20px}h4{font-size:18px}h5{font-size:16px}h6{font-size:12px}p,span,a{font-size:14px}a,a:focus,a:hover{cursor:pointer;color:inherit;text-decoration:none}ul{list-style:none}label{text-align:right;color:#666666;font-size:14px}\n", ""]);

// exports
